<template>
  <div id="groups-list">
    <Message :message="message" :type="type" v-if="message !==''"></Message>
    <h2 class="title">{{$t('groups.title')}}</h2>
    <div class="content">
      <div class="controls" v-if="loaded">
        <div class="buttons">
          <div class="adds">
            <div class="add-link">
              <font-awesome-icon @click="addGroup" icon="plus-circle" size="lg"></font-awesome-icon>
              <a @click.prevent="addGroup" href="/">{{$t('groups.add')}}</a>
            </div>

          </div>
          <div class="ops">
            <SubmitButton @save="saveChanges"></SubmitButton>
            <CancelButton @cancel="cancel"></CancelButton>
          </div>
        </div>
        <div class="search-container">
          <input :placeholder="$t('groups.search')" @blur="magic_flag = false"
                 @focus="magic_flag = true"
                 type="text"
                 v-model="search"/>
        </div>
      </div>
      <div class="table-container">
        <div class="table">
          <div class="tr" v-if="loaded">
            <span class="td">{{$t('general.number-order')}}</span>
            <span class="td">{{$t('groups.name')}}</span>
            <span class="td">{{$t('groups.salons')}}</span>
            <span class="td">{{$t('general.operations')}}</span>
          </div>
          <Group :group="group" v-if="loaded"
                 :index="index+1"
                 :key="group.id" @remove="remove"
                 @delete="deleteGroup"
                 @edited="moveToEdited" v-for="(group,index) in groupList">
          </Group>
          <Preloader v-if="!loaded"></Preloader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Group from '@/components/groups/Group.vue';
import {RepositoryFactory} from '@/api/RepositoryFactory';
import Preloader from '@/components/helpers/Preloader.vue';
import Message from '@/components/helpers/Message';
import SubmitButton from '@/components/helpers/SubmitButton.vue';
import CancelButton from '@/components/helpers/CancelButton.vue';
import {GroupHasReportsError} from '../../api/user/erros';

const GroupRepository = RepositoryFactory.get('groups');
const SalonsRepository = RepositoryFactory.get('salons');

export default {
  name: 'GroupsList',
  components: {
    Group,
    Preloader,
    Message,
    CancelButton,
    SubmitButton,
  },
  data() {
    return {
      edited: [],
      users: [],
      search: '',
      loaded: true,
      groups: [],
      deleteGroupIds: [],
      message: '',
      type: 'info',
      dummyId: -1,
      newGroups: [],
    };
  },
  mounted() {
    this.getGroups();
  },
  methods: {
    moveToEdited(key) {
      if (key >= 0) {
        const group = this.filteredGroups.find(groupF => groupF.id === key);
        if (group !== undefined) {
          if (!this.edited.includes(group)) {
            this.edited.push(group);
            this.groups.splice(this.groups.indexOf(group), 1);
          }
        }
      }
    },
    deleteGroup(key) {
      const index = this.newGroups.findIndex(group => group.id === key);
      this.newGroups.splice(index, 1);
    },
    getGroups() {
      this.loaded = false;
      const { token } = this.$store.getters;
      GroupRepository.getAllGroups(token).then((response) => {
        this.groups = response;
        this.groups.forEach((v) => {
          v.newShopsList = [];
          v.detachShopIds = [];
        });
        this.loaded = true;
      })
        .catch((error) => {
          this.groups = [];
          this.message = this.$t('errors.genericError');
          this.type = 'error';
        });
    },
    async saveChanges() {
      this.loaded = false;
      this.message = this.$t('messages.genericWait');
      this.type = 'warning';
      const groups = {
        groups: [],
        deleteGroupIds: this.deleteGroupIds,
      };
      this.newGroups.forEach((v) => {
        const group = {
          shops: v.newShopsList,
          name: v.name,
        };
        groups.groups.push(group);
      });
      this.edited.forEach((v) => {
        if (this.deleteGroupIds.indexOf(v.id) === -1) {
          const group = {
            shops: v.newShopsList,
            detachShopIds: v.detachShopIds,
            name: v.name,
          };
          if (v.id >= 0) {
            group.id = v.id;
          }
          groups.groups.push(
            group,
          );
        }
      });
      const { token } = this.$store.getters;
      try {
        await GroupRepository.crudGroups(token, groups);
        this.$store.commit('set_store_state', false);
        this.edited = [];
        this.newGroups = [];
        this.search = '';
        await this.getGroups();
        const contextGroups = await GroupRepository.getContextualGroups(token);
        this.$store.commit('set_groups', contextGroups);
        const salons = await SalonsRepository.getShopsGroup(token, this.$store.getters.selectedGroup.id);
        await this.$store.dispatch('setSalons', salons);
        this.message = this.$t('messages.genericSave');
        this.type = 'info';
      } catch (error) {
        if (error instanceof GroupHasReportsError) {
          this.deleteGroupIds = [];
          this.message = `${this.$t('groups.messages.groupRemoval')}: ${error.message}`;
          this.type = 'error';
        }
      } finally {
        this.$store.commit('set_store_state', true);
        this.loaded = true;
      }
    },
    cancel() {
      this.groups = [];
      this.edited = [];
      this.newGroups = [];
      this.search = '';
      this.getGroups();
      this.message = this.$t('messages.genericCancel');
      this.type = 'info';
    },
    addGroup() {
      this.dummyId--;
      this.newGroups.unshift({
        id: this.dummyId,
        name: '',
        shops: [],
        newShopsList: [],
        detachShopIds: [],
      });
    },
    remove(id) {
      if (this.deleteGroupIds.includes(id)) {
        const index = this.deleteGroupIds.indexOf(id);
        this.deleteGroupIds.splice(index, 1);
      } else {
        this.deleteGroupIds.push(id);
      }
    },

  },
  computed: {
    filteredGroups() {
      return this.groups.filter(group => group.name.toLowerCase().includes((this.search.toLowerCase())));
    },
    groupList() {
      return this.newGroups.concat(this.edited.concat(this.filteredGroups));
    },
  },
};
</script>

<style lang="scss" scoped>
  #groups-list {
    /*width: 1510px;*/
    margin: 0 auto;
  }

  h2 {
    font-size: rem(30px);
    font-weight: 800;
    text-align: left;
    // color: $baseTextColor;
  }

  DIV.table {
    display: table;
    background: white;
    box-shadow: 0 5px 6px rgba(0, 0, 0, 0.15);
    padding: 46px 36px;
    border-radius: 5px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    border-collapse: separate;
    @include media('<768px') {
      min-width: 1000px;
    }
    // color: $baseTextColor;
  }

  FORM.tr, DIV.tr {
    display: table-row;
  }

  div.tr {
    border: none;

    &:first-child {
      font-weight: bold;

      > .td {
        border-bottom: 1px solid $border-blue;
        padding-bottom: 16px;
        line-height: 18px;
      }
    }

    > .td {
      border-top: none;
      font-size: rem(14px);
      line-height: 19px;
    }
  }

  SPAN.td {
    display: table-cell;
    border: none;

    &:first-child {
      border-left: none;
    }

    &:last-child {
      border-right: none;

    }
  }

  .table-container {
    overflow: visible;
    @include media('<1450px') {
      overflow-x: scroll;
    }
  }

  .controls {
    margin-bottom: 35px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @include media('<1450px') {
      flex-wrap: wrap;
    }

    .buttons {
      display: flex;
      @include media('<1450px') {
        width: 100%;
        justify-content: space-between;
      }
      @include media('<470px') {
        flex-direction: column;
      }

      .adds, .ops {
        display: flex;
        justify-content: space-between;
        @include media('<1200px') {
          flex-direction: column;
        }
        @include media('<1025px') {
          flex-direction: row;
          width: 100%;
        }
        @include media('<776px') {
          flex-direction: column;
        }

      }

      .adds {
        @include media('<1200px') {
          align-items: baseline;
          justify-content: center;
        }
        @include media('<776px') {
          align-items: baseline;
          justify-content: center;
        }
      }

      .ops {
        button {
          @include media('<1200px') {
            margin: 5px 0;
          }
        }
      }

    }

    .search-container {
      width: 611px;
      margin-left: auto;
      @include media('<1450px') {
        width: 100%;
        margin-top: 15px;
        margin-left: 0;
      }
    }

    input {
      border: 1px solid #e5e5e5;
      width: 100%;
      box-sizing: border-box;
      padding: 20px 40px;
      border-radius: 5px;
      margin-left: auto;

    }

    button {
      border: none;
      background: none;
      cursor: pointer;
      color: #005fab;
      font-size: rem(18px);
      font-weight: bold;

      &.cancel, &.save {

        color: white;
        font-size: rem(18px);
        font-weight: bold;
        padding: 12px 50px;
        border-radius: 30px;
        transition: 300ms all ease-in;

      }

      &.save {
        background: #005fab;
        border: 1px solid #005fab;
        margin-left: 60px;
        margin-right: 21px;

        &:hover {
          color: #005fab;
          background: white;
        }
      }

      &.cancel {
        background-color: #002678;
        border: 1px solid #002678;

        &:hover {
          color: #002678;
          background: white;
        }
      }
    }

    .add-link {
      font-size: rem(18px);
      color: #005fab;
      font-weight: 900;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 36px;
      text-align: left;

      a {
        margin-left: 17px;
        text-decoration: none;

        &:active, &:hover, &:visited {
          color: #005fab;
        }
      }

    }
  }

  .button-container {
    padding: 0 15px;
  }

  svg {
    cursor: pointer;
  }
</style>
